(() => {
  const publish = (eventName, payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
    window.Shopify?.analytics?.publish?.(`the_limely:${eventName}`, payload);
  };

  const initialiseArticle = (root) => {
    if (root.dataset.limelyArticleReady === 'true') return;

    const body = root.querySelector('[data-limely-article-body]');
    const toc = root.querySelector('[data-limely-article-toc]');
    const list = root.querySelector('[data-limely-article-toc-list]');
    if (!body || !toc || !list) return;

    const headings = [...body.querySelectorAll(':scope > h2')];
    const shopBlocks = [...body.querySelectorAll(':scope > [data-limely-article-shop-block]')];

    const articleHandle = (root.dataset.articleHandle || '').split('/').pop() || '';
    const articlePayload = {
      article_handle: articleHandle,
      article_path: window.location.pathname,
      blog_handle: root.dataset.blogHandle || ''
    };

    publish('journal_article_view', articlePayload);

    root.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const lineSupportLink = event.target.closest('[data-journal-line-support-link]');
      if (lineSupportLink) {
        publish('journal_line_support_click', {
          ...articlePayload,
          support_type: 'line',
          destination_host: new URL(lineSupportLink.href, window.location.href).host
        });
        return;
      }

      const jumpLink = event.target.closest('[data-journal-shop-jump]');
      if (jumpLink) {
        publish('journal_shop_story_jump', articlePayload);
        return;
      }

      const collectionLink = event.target.closest('[data-journal-collection-link]');
      if (collectionLink) {
        const shopBlock = collectionLink.closest('[data-limely-article-shop-block]');
        publish('journal_collection_click', {
          ...articlePayload,
          destination_path: new URL(collectionLink.href, window.location.origin).pathname,
          block_position: Number.parseInt(shopBlock?.dataset.shopBlockPosition || '', 10) || null
        });
        return;
      }

      const link = event.target.closest('a[href*="/products/"]');
      if (!link || !root.contains(link)) return;

      const productCard = link.closest('product-card[handle]');
      const shopBlock = link.closest('[data-limely-article-shop-block]');
      const productUrl = new URL(link.href, window.location.origin);
      const productHandle = productCard?.getAttribute('handle')
        || productUrl.pathname.split('/products/')[1]?.split('/')[0]
        || '';

      if (!productHandle) return;

      const cardPosition = productCard && shopBlock
        ? [...shopBlock.querySelectorAll('product-card[handle]')].indexOf(productCard) + 1
        : null;
      const linkType = link.classList.contains('product-card__media')
        ? 'image'
        : link.classList.contains('limely-article__product-image')
          ? 'featured_image'
          : link.classList.contains('limely-article__product-link')
            ? 'featured_cta'
            : 'title';
      const payload = {
        ...articlePayload,
        product_handle: productHandle,
        product_path: productUrl.pathname,
        module: shopBlock ? 'editorial_product_grid' : 'featured_product',
        block_position: shopBlock ? Number.parseInt(shopBlock.dataset.shopBlockPosition || '', 10) || null : null,
        card_position: cardPosition > 0 ? cardPosition : null,
        link_type: linkType
      };

      window.dispatchEvent(new CustomEvent('thelimely:journal-product-click', { detail: payload }));
      publish('journal_product_click', payload);
    });

    shopBlocks.forEach((block) => {
      const sectionCount = Number.parseInt(block.dataset.insertAfterSections || '', 10);
      const anchor = Number.isFinite(sectionCount) ? headings[sectionCount] : null;
      if (anchor) body.insertBefore(block, anchor);
    });

    if (headings.length === 0) {
      toc.hidden = true;
      root.dataset.limelyArticleReady = 'true';
      return;
    }

    const links = headings.map((heading, index) => {
      const id = heading.id || `journal-section-${index + 1}`;
      heading.id = id;
      heading.style.scrollMarginTop = '130px';

      const item = document.createElement('li');
      const number = document.createElement('span');
      const link = document.createElement('a');
      number.textContent = String(index + 1).padStart(2, '0');
      number.setAttribute('aria-hidden', 'true');
      link.href = `#${id}`;
      link.textContent = heading.textContent.trim();
      link.dataset.limelyArticleTocLink = id;
      item.append(number, link);
      list.append(item);
      return link;
    });

    const desktop = window.matchMedia('(min-width: 1000px)');
    const syncTocState = (event) => {
      if (!toc.dataset.userToggled) toc.open = event.matches;
    };
    syncTocState(desktop);
    desktop.addEventListener?.('change', syncTocState);
    toc.addEventListener('toggle', () => {
      if (document.readyState === 'complete') toc.dataset.userToggled = 'true';
    });

    if ('IntersectionObserver' in window) {
      const seenCommerceModules = new WeakSet();
      const commerceObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || seenCommerceModules.has(entry.target)) return;
          seenCommerceModules.add(entry.target);

          const blockPosition = Number.parseInt(entry.target.dataset.shopBlockPosition || '', 10) || null;
          const productHandles = [...entry.target.querySelectorAll('product-card[handle]')]
            .map((card) => card.getAttribute('handle'))
            .filter(Boolean);

          publish('journal_product_impression', {
            ...articlePayload,
            module: 'editorial_product_grid',
            block_position: blockPosition,
            product_handles: productHandles.join(','),
            product_count: productHandles.length
          });
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.2 });
      shopBlocks.forEach((block) => commerceObserver.observe(block));

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (!visible) return;
        links.forEach((link) => {
          link.toggleAttribute('aria-current', link.dataset.limelyArticleTocLink === visible.target.id);
        });
      }, { rootMargin: '-18% 0px -70% 0px' });
      headings.forEach((heading) => observer.observe(heading));
    }

    root.dataset.limelyArticleReady = 'true';
  };

  document.querySelectorAll('[data-limely-article]').forEach(initialiseArticle);
})();
